export default __webpack_public_path__ + "static/media/six.f5af83e3.svg";